export default __webpack_public_path__ + "static/media/noa-27.7811b527.jpg";